import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {typeAction} from "../features/filter/filterSlice";

export default function Sidebar() {  
  const dispatch = useDispatch();
  const {type} = useSelector((state)=> state.filter);  
  return (
    <div className="sidebar">
      <nav>
        <ul className="space-y-4">
          <li>
            <Link
              to={"/"}
              className={`main-menu ${type==='All' ? 'menu-active': ''}`}
              id="lws-alljobs-menu"
              onClick={()=> dispatch(typeAction('All'))}
            >
              <i className="fa-solid fa-briefcase"></i>{" "}
              <span>All Available Jobs</span>
            </Link>
            <ul className="space-y-6 lg:space-y-2 ">
              <li>
                <Link
                  className="sub-menu"              
                  id="lws-internship-menu"
                  to={'/'}
                  onClick={()=> dispatch(typeAction('Internship'))}
                >
                  <i className="fa-solid fa-stop !text-[#FF5757]"></i>
                  {" "} Internship
                </Link>
              </li>
              <li>
                <Link
                  className="sub-menu"
                  to={'/'}                  
                  id="lws-fulltime-menu"
                  onClick={()=> dispatch(typeAction('Full Time'))}
                >
                  <i className="fa-solid fa-stop !text-[#FF8A00]"></i>
                  {" "} Full Time
                </Link>
              </li>
              <li>
                <Link
                  className="sub-menu"
                  to={'/'}
                  id="lws-remote-menu"
                  onClick={()=> dispatch(typeAction('Remote'))}
                >
                  <i className="fa-solid fa-stop !text-[#56E5C4]"></i>
                  {" "} Remote
                </Link>
              </li>
            </ul>
          </li>
          <li>
            <Link to={"add"} className="main-menu" id="lws-addJob-menu">
              <i className="fa-solid fa-file-circle-plus"></i> {" "}
              <span>Add NewJob</span>
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  );
}
